import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=29901879&scoped=true&"
var script = {}
import style0 from "./Telegram.vue?vue&type=style&index=0&id=29901879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29901879",
  null
  
)

export default component.exports